import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Campaign {
  id: string
  name: string
  campaign_category?: string
}

export interface UseCampaignsResult {
  campaigns: Campaign[]
  loading: boolean
  error: string | null
  refetch: (campaignCategory?: string) => Promise<void>
}

export function useCampaigns(campaignCategory?: string): UseCampaignsResult {
  const [campaigns, setCampaigns] = useState<Campaign[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (currentCampaignCategory?: string): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const url = currentCampaignCategory 
        ? `/admin/web-contact-management/campaigns/dropdown?campaignCategory=${currentCampaignCategory}`
        : '/admin/web-contact-management/campaigns/dropdown'
      console.log('Fetching campaigns from:', url)
      const res = await api.get<{ campaigns: Campaign[] }>(url)
      console.log('Campaigns response:', res)
      setCampaigns(res.campaigns || [])
    } catch (e) {
      console.error('Failed to fetch campaigns:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch campaigns')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refetch(campaignCategory)
  }, [campaignCategory, refetch])

  return { campaigns, loading, error, refetch }
}
